export default "__VITE_ASSET__COY7K9J1__"